<template>
  <div>
   <reports />
  </div>
</template>

<script>
import reports from '../../../../components/tax/delinquent/juneResale/Reports.vue';

export default {
  name: 'JuneResaleReports',
  components: {
    reports,
  },
};
</script>
